import { useStatic } from '~/common/hooks/useStatic';
import {
  cancelableRequestFactory,
  RequestConfig,
} from '~/common/services/requests';
import { useEventHandler } from '../../../../hooks/useEventHandler';

export const useExternalRequest = () => {
  // the factory owns the in-flight cancellation registry
  const performCancelableRequest = useStatic(() => cancelableRequestFactory());

  const performRequest = useEventHandler(
    async <ResponseType>(config: RequestConfig) => {
      const response = await performCancelableRequest<ResponseType>(config);
      return response;
    },
  );

  return performRequest;
};
